import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { clearSettings } from "../../store/App";
import { useDispatch } from "react-redux";
import { resetSessionAuth } from "../../store/Session";
import { clearMenuOptions } from "../../store/UI";

export const useAxiosInterceptor = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    // Add a response interceptor to handle 401 Unauthorized errors
    // and redirect to the login page
    // This interceptor will also clear the session and settings
    // when a 401 error occurs
    // and will clear the menu options in the UI store
    const responseInterceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error?.response?.status === 401) {
            dispatch(clearSettings());
            dispatch(resetSessionAuth());
            dispatch(clearMenuOptions());
            sessionStorage.clear();
            return navigate('/')            
        } else {
            return Promise.reject(error);
        }
      }
    );

    return () => {
      axios.interceptors.response.eject(responseInterceptor);
    };
  }, [navigate]);

  return null;
};